import { hydrate } from 'davaux/client'
import __island_0 from "/cabinet/Dev/Davaux/davaux.docs/src/components/ThemeToggle.tsx"

hydrate({
  "components/ThemeToggle": async () => ({ default: __island_0 }),
})